<template>
    <div>
      <v-overlay :value="loading" absolute>
          <v-progress-circular indeterminate size="64" color="primary" />
      </v-overlay>
      <div v-if="!loading">
        <app-form
          v-bind:parentObject="{
            data: this.formData,
            searchnew: this.search,
            pageTitle: this.pageTitle,
            pageTitleValue: this.pageTitleValue,
            errMsg: this.errMsg,
            isEdit: this.editMode,
          }"
          v-on:input="formData = $event"
          v-on:new="createHandler"
          v-on:save="saveHandler"
          v-on:delete="isConfirm = !isConfirm"
          v-on:error="errorHandler"
        />
    
        <div v-if="isErr">
          <app-error
            v-bind:parentError="{
              data: this.errMsg,
              isErr: this.isErr,
            }"
            v-on:closeError="isErr = $event"
          />
        </div>
    
        <div v-if="isConfirm">
          <app-confirm
            v-bind:parentObject="{
              pageTitleValue: this.pageTitleValue,
              isConfirm: this.isConfirm,
            }"
            v-on:confirm="deleteHandler($event)"
            v-on:cancelConfirm="isConfirm = !isConfirm"
          />
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import moment from 'moment';
  import GLCodeMappingPolicyForm from "../../../components/payroll/glcodemappinglisting/Form";
  import ErrorDialog from "../../../components/common/ErrorDialog";
  import ConfirmDialog from "../../../components/common/ConfirmDialog";
  
  export default {
    components: {
      "app-form": GLCodeMappingPolicyForm,
      "app-error": ErrorDialog,
      "app-confirm": ConfirmDialog,
    },
  
    data() {
      return {
        id: this.$route.params.id,
        search: this.$route.params.search,
        pageTitle: "Edit GL Code Mapping Policy",
        pageTitleValue: "",
        formData: {
          id: null,
          payglmappolicyid: null,
          startdate: null,
          enddate: null,
          payglmappolicylistdetail: [],
          stamp: 0,
          userid: this.$store.getters.userId,
        },
        loading: true,
        errMsg: "",
        isErr: false,
        isConfirm: false,
        editMode: false,
      };
    },
  
    methods: {
      errorHandler($event) {
        this.isErr = $event.isErr;
        this.errMsg = $event.errMsg;
      },
  
      async loadGLCodeMappingPolicyListingItem() {
        const vm = this;
  
        try {
          const res = await this.$store.dispatch('get', {url: "/payglcodemappingpolicylist/" + this.id})

          vm.formData.id = res.data.rec[0].id;
          vm.formData.payglmappolicyid = res.data.rec[0].payglmappolicyid;
          vm.formData.startdate = moment(res.data.rec[0].startdate).format('YYYY-MM-DD');
          vm.formData.enddate = moment(res.data.rec[0].enddate).format('YYYY-MM-DD');
          
          vm.formData.stamp = res.data.rec[0].stamp;

          vm.pageTitleValue = res.data.rec[0].policydesc;
          await this.loadGLCodeMappingPolicyListingDetailItem()
        }
        catch(err) {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        }
      },

      loadGLCodeMappingPolicyListingDetailItem() {
        const vm = this;

        return this.$store.dispatch('get', {url: "/payglcodemappingpolicylistdetailbyid/" + this.id})
          .then((res) => {
            vm.formData.payglmappolicylistdetail = res.data.rec;

            for (let i = 0; i < vm.formData.payglmappolicylistdetail.length; i++) {
              Object.assign(vm.formData.payglmappolicylistdetail[i], {
                action: 2,
              });
            }

            vm.loading = false;
          })
          .catch((err) => {
            vm.isErr = !vm.isErr;
            vm.errMsg = err;
          });
      },
  
      saveHandler() {
        const vm = this;
  
        if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
          return false;
        }
  
        this.$store.dispatch('put', {url: "/payglcodemappingpolicylist/" + this.id,
            payload: this.formData})
          .then((res) => {
            if (res.data.error) {
              vm.isErr = !vm.isErr;
              vm.errMsg = res.data.error;
            } else {
              this.$router.push({ name: "glcodemappinglistinglist", params: { search: this.search}  });
            }
          })
          .catch((err) => {
            vm.isErr = !vm.isErr;
            vm.errMsg = err;
          });
      },
  
      deleteHandler() {
        const vm = this;
  
        if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
          return false;
        }
  
        this.$store.dispatch('delete', {url:
              "/payglcodemappingpolicylist/" +
              this.id +
              "/" +
              this.formData.userid})
          .then((res) => {
            if (res.data.error) {
              vm.isErr = !vm.isErr;
              vm.errMsg = res.data.error;
            } else {
              this.$router.push({ name: "glcodemappinglistinglist" });
            }
          })
          .catch((err) => {
            vm.isErr = !vm.isErr;
            vm.errMsg = err;
          });
      },
  
      createHandler() {
        this.$router.push({ name: "glcodemappinglistingnew" });
      },
    },
  
    async mounted() {
      this.editMode = true;
      await this.loadGLCodeMappingPolicyListingItem();
    },
  };
  </script>